export const parametertHeader = [{
  prop: 'STORAGE_NO',
  label: '台账号'
}, {
  prop: 'CHEM_NAME',
  label: '试剂名称'
}, {
  prop: 'CHEM_ID',
  label: 'CAS号'
}, {
  prop: 'CABINET_ID',
  label: '柜号'
}, {
  prop: 'PURTY',
  label: '纯度'
}, {
    prop: 'CURRENT_VOLUME',
    label: '余量'
}, {
  prop: 'VALUMEUNIT_ID',
  label: '容量单位'
}, {
  prop: 'REMARK',
  label: '备注'
}
// , {
//     prop: 'ONLINE_STATUS_V',
//     label: '二维码'
// }, {
//     prop: 'ONLINE_STATUS_V',
//     label: '空桶回收'
// }
]

